import { computed } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { usePipedriveStore } from '../..';
import useCircleWithRadius from '../../hooks/useCircleWithRadius';
import useCircleWithRadiusOnMap from '../../hooks/useCircleWithRadiusOnMap';
import { useRecordedSalesInRadius, useRecordedSalesInStore } from '../../hooks/useRecordedSales';
import { IDetailsTabProps } from "../../interfaces/IDetailsTabProps";
import { formatNumber } from '../../utils/utils';
import RadiusDropdown from '../RadiusDropdown';
import RecordedSalesGrid from '../RecordedSalesGrid';

function DealDetailsRecordedSalesTab({ visible, setEntityCount }: IDetailsTabProps) {
    const { id } = useParams();
    const pipedriveStore = usePipedriveStore();
    const deal = useMemo(() => computed(() => pipedriveStore.deals.find(d => d.id.toString() === id)!), [id]).get();
    const coordinates = useMemo(() => ({ latitude: deal.lat, longitude: deal.lon }), [deal]);
    const [radius, setRadius] = useState(5);
    const circle = useCircleWithRadius(coordinates, radius)!;
    useCircleWithRadiusOnMap(coordinates, radius, visible, "DealDetailsRecordedSalesTab");
    const recordedSales = useRecordedSalesInRadius(coordinates, radius);
    useRecordedSalesInStore(visible ? recordedSales : []);

    useEffect(() => setEntityCount(recordedSales.length), [recordedSales]);

    if (!visible)
        return null;

    return (
        <RecordedSalesGrid
            recordedSales={recordedSales}
            additionalHeaders={[{
                titleStrings: ["DISTANCE"],
                getValue: item => circle!.getDistanceFromCenter(item.centerPoint),
                getLabel: item => {
                    const distance = circle!.getDistanceFromCenter(item.centerPoint);
                    return distance ? formatNumber(distance) : "";
                }
            }]}
            radiusDropdown={<RadiusDropdown value={radius} onChange={setRadius} />}
        />
    );
}

export default observer(DealDetailsRecordedSalesTab);